import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-metadata-change-response" },
    [
      _c("h5", [
        _vm._v(
          "Table: " +
            _vm._s(
              _vm._f("joinTableReference")(
                _vm.userRequestMetadata.tableReference
              )
            )
        ),
      ]),
      _c("hr"),
      _vm.userRequestMetadata && _vm.defaultRequestChangeFields
        ? _c(
            "b-form",
            { staticClass: "form", on: { submit: _vm.onSubmit } },
            [
              _c(
                VTabs,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(VTab, [
                    _vm._v(_vm._s(_vm.$t("my_tasks.modals.general"))),
                  ]),
                  _c(VTab, [
                    _vm._v(_vm._s(_vm.$t("my_tasks.modals.columns"))),
                  ]),
                  _c(VTab, [
                    _vm._v(_vm._s(_vm.$t("my_tasks.modals.hlogs"))),
                  ]),
                ],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { lg: "6" } },
                            [
                              _c("h6", [_vm._v("Original")]),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.organization"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .ORGANIZATION.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .ORGANIZATION.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.ORGANIZATION.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.domain")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS.DOMAIN.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS.DOMAIN
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DOMAIN.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.subdomain"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN
                                                .name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.SUBDOMAIN.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.official_source"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .OFFICIAL_SOURCE.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .OFFICIAL_SOURCE.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.OFFICIAL_SOURCE.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.operator")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS.OPERATOR
                                                .name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS.OPERATOR
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.environment"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                                .name
                                            ].enumValue.displayName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .ENVIRONMENT.name
                                              ].enumValue,
                                              "displayName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.zone")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.ZONE.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.area")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS.AREA.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS.AREA.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.AREA.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.public")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VCheckbox, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultActualMetadataFields[
                                              _vm.DEFAULT_TPL_FIELDS.PUBLIC.name
                                            ].boolValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultActualMetadataFields[
                                                _vm.DEFAULT_TPL_FIELDS.PUBLIC
                                                  .name
                                              ],
                                              "boolValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.PUBLIC.name].boolValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.showAuthorizationTypeCompare &&
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.AUTHORIZATION_TYPE.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.authorization_type"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              value: _vm.authorizationTypeLabel(
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .AUTHORIZATION_TYPE.name
                                                ].stringValue
                                              ),
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.bus_data_steward"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .BUS_DATA_STEWARD.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultActualMetadataFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .BUS_DATA_STEWARD.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.DATA_OWNER.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.data_owner"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .DATA_OWNER.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultActualMetadataFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .DATA_OWNER.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DATA_OWNER.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.tech_data_custodiam"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TECH_DATA_CUSTODIAM.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultActualMetadataFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TECH_DATA_CUSTODIAM.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.FINAL_TABLE.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.final_table"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VCheckbox, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .FINAL_TABLE.name
                                                ].boolValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultActualMetadataFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .FINAL_TABLE.name
                                                  ],
                                                  "boolValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.FINAL_TABLE.name].boolValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.description"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextarea, {
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          disabled: "",
                                          "no-resize": "",
                                          "hide-details": "",
                                          rows: "3",
                                        },
                                        model: {
                                          value: _vm.completeDescription1,
                                          callback: function ($$v) {
                                            _vm.completeDescription1 = $$v
                                          },
                                          expression: "completeDescription1",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.UPLOAD_PLATFORM.name
                              ]
                                ? _c(
                                    VRow,
                                    {
                                      staticClass: "mt-1",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.upload_platform"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .UPLOAD_PLATFORM.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultActualMetadataFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .UPLOAD_PLATFORM.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.UPLOAD_PLATFORM.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.UPLOAD_PROCESS.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.upload_process"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .UPLOAD_PROCESS.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultActualMetadataFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .UPLOAD_PROCESS.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.UPLOAD_PROCESS.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.load_logic"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TABLE_LOAD_LOGIC.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultActualMetadataFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TABLE_LOAD_LOGIC.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultActualMetadataFields[
                                _vm.DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.tables_relationship"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextarea, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultActualMetadataFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TABLES_RELATIONSHIP.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultActualMetadataFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TABLES_RELATIONSHIP.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultActualMetadataFields[DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "6" } },
                            [
                              _c("h6", [
                                _vm._v(
                                  _vm._s(_vm.$t("my_tasks.modals.request"))
                                ),
                              ]),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.organization"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.ORGANIZATION
                                            .name
                                        ),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .ORGANIZATION.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .ORGANIZATION.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.ORGANIZATION.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.domain")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.DOMAIN.name
                                        ),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS.DOMAIN.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS.DOMAIN
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DOMAIN.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.subdomain"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN.name
                                        ),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN
                                                .name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.SUBDOMAIN.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.official_source"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.OFFICIAL_SOURCE
                                            .name
                                        ),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .OFFICIAL_SOURCE.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .OFFICIAL_SOURCE.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.OFFICIAL_SOURCE.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.operator")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.OPERATOR.name
                                        ),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS.OPERATOR
                                                .name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS.OPERATOR
                                                  .name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.environment"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                            .name
                                        ),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                                .name
                                            ].enumValue.displayName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .ENVIRONMENT.name
                                              ].enumValue,
                                              "displayName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.zone")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                        ),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.ZONE.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.area")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextField, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.AREA.name
                                        ),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS.AREA.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS.AREA.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.AREA.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.public")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VCheckbox, {
                                        class: _vm.classDiff(
                                          _vm.DEFAULT_TPL_FIELDS.PUBLIC.name
                                        ),
                                        attrs: {
                                          "hide-details": "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultRequestChangeFields[
                                              _vm.DEFAULT_TPL_FIELDS.PUBLIC.name
                                            ].boolValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultRequestChangeFields[
                                                _vm.DEFAULT_TPL_FIELDS.PUBLIC
                                                  .name
                                              ],
                                              "boolValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.PUBLIC.name].boolValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.showAuthorizationTypeCompare &&
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.AUTHORIZATION_TYPE.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.authorization_type"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS
                                                .AUTHORIZATION_TYPE.name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              value: _vm.authorizationTypeLabel(
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .AUTHORIZATION_TYPE.name
                                                ].stringValue
                                              ),
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.bus_data_steward"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS
                                                .BUS_DATA_STEWARD.name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .BUS_DATA_STEWARD.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultRequestChangeFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .BUS_DATA_STEWARD.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.DATA_OWNER.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.data_owner"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS.DATA_OWNER
                                                .name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .DATA_OWNER.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultRequestChangeFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .DATA_OWNER.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DATA_OWNER.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.tech_data_custodiam"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS
                                                .TECH_DATA_CUSTODIAM.name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TECH_DATA_CUSTODIAM.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultRequestChangeFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TECH_DATA_CUSTODIAM.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.FINAL_TABLE.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.final_table"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VCheckbox, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS.FINAL_TABLE
                                                .name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .FINAL_TABLE.name
                                                ].boolValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultRequestChangeFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .FINAL_TABLE.name
                                                  ],
                                                  "boolValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.FINAL_TABLE.name].boolValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.description"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    [
                                      _c(VTextarea, {
                                        class: _vm.classDiffDescription(),
                                        attrs: {
                                          dense: "",
                                          filled: "",
                                          disabled: "",
                                          "no-resize": "",
                                          "hide-details": "",
                                          rows: "3",
                                        },
                                        model: {
                                          value: _vm.completeDescription2,
                                          callback: function ($$v) {
                                            _vm.completeDescription2 = $$v
                                          },
                                          expression: "completeDescription2",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.UPLOAD_PLATFORM.name
                              ]
                                ? _c(
                                    VRow,
                                    {
                                      staticClass: "mt-1",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.upload_platform"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS
                                                .UPLOAD_PLATFORM.name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .UPLOAD_PLATFORM.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultRequestChangeFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .UPLOAD_PLATFORM.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.UPLOAD_PLATFORM.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.UPLOAD_PROCESS.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.upload_process"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS
                                                .UPLOAD_PROCESS.name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .UPLOAD_PROCESS.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultRequestChangeFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .UPLOAD_PROCESS.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.UPLOAD_PROCESS.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.load_logic"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS
                                                .TABLE_LOAD_LOGIC.name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TABLE_LOAD_LOGIC.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultRequestChangeFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TABLE_LOAD_LOGIC.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.defaultRequestChangeFields[
                                _vm.DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.tables_relationship"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextarea, {
                                            class: _vm.classDiff(
                                              _vm.DEFAULT_TPL_FIELDS
                                                .TABLES_RELATIONSHIP.name
                                            ),
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.defaultRequestChangeFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TABLES_RELATIONSHIP.name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .defaultRequestChangeFields[
                                                    _vm.DEFAULT_TPL_FIELDS
                                                      .TABLES_RELATIONSHIP.name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultRequestChangeFields[DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "cont-multiple-table-scroll" },
                        [
                          _vm.defaultActualMetadataFields
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "original-col",
                                  attrs: { xs: "6", sm: "6", lg: "6" },
                                },
                                [
                                  _c("h6", [_vm._v("Original")]),
                                  _c("list-table-metadata-cols", {
                                    attrs: {
                                      columnFields: _vm.alignedActualColumns,
                                      defaultFields:
                                        _vm.defaultActualMetadataFields,
                                      isChangeRequest:
                                        _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                                      showTransformationLogic: true,
                                      showTitle: false,
                                      paginationConfig: {
                                        limit:
                                          _vm.alignedActualColumns.length ||
                                          100,
                                        total: _vm.alignedActualColumns.length,
                                        page: 1,
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.defaultRequestChangeFields
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "request-col",
                                  attrs: { xs: "6", sm: "6", lg: "6" },
                                },
                                [
                                  _c("h6", [_vm._v("Required")]),
                                  _c("list-table-metadata-cols", {
                                    attrs: {
                                      changes: _vm.changes,
                                      columnFields:
                                        _vm.columnRequestChangeFields,
                                      defaultFields:
                                        _vm.defaultRequestChangeFields,
                                      isChangeRequest:
                                        _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                                      showTransformationLogic: true,
                                      showTitle: false,
                                      paginationConfig: {
                                        limit:
                                          _vm.columnRequestChangeFields
                                            .length || 100,
                                        total:
                                          _vm.columnRequestChangeFields.length,
                                        page: 1,
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _vm.serverActualMetadata.tableInfo
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { sm: "12", lg: "12" } },
                                [
                                  _c("list-table-logs", {
                                    attrs: {
                                      objectId:
                                        _vm.serverActualMetadata.tableInfo
                                          .relativeResourceName,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("hr"),
              _vm.serverActualMetadata.tipo == "vista"
                ? [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12", lg: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "sm",
                                  label: _vm.$t(
                                    "my_tasks.modals.request_reason"
                                  ),
                                },
                              },
                              [
                                _c("b-form-textarea", {
                                  staticClass: "input-min",
                                  attrs: {
                                    disabled: "",
                                    size: "sm",
                                    rows: "3",
                                    "max-rows": "3",
                                  },
                                  model: {
                                    value: _vm.userRequestMetadata.commentary,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.userRequestMetadata,
                                        "commentary",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "userRequestMetadata.commentary",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12", lg: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "sm",
                                  label: _vm.$t("my_tasks.response_request"),
                                },
                              },
                              [
                                _c("b-form-textarea", {
                                  staticClass: "input-mini",
                                  attrs: {
                                    disabled: "",
                                    size: "sm",
                                    rows: "3",
                                    "max-rows": "3",
                                  },
                                  model: {
                                    value: _vm.userRequestMetadata.response,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.userRequestMetadata,
                                        "response",
                                        $$v
                                      )
                                    },
                                    expression: "userRequestMetadata.response",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.serverActualMetadata.tipo == "edicion"
                ? [
                    _vm.userRequestMetadata.commentary
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: _vm.$t(
                                        "my_tasks.modals.request_reason"
                                      ),
                                    },
                                  },
                                  [
                                    _c(VTextarea, {
                                      attrs: {
                                        filled: "",
                                        dense: "",
                                        rows: "3",
                                        "max-rows": "3",
                                        type: "text",
                                        required: "",
                                        placeholder: "Message...",
                                        readonly: "",
                                      },
                                      model: {
                                        value:
                                          _vm.userRequestMetadata.commentary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userRequestMetadata,
                                            "commentary",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "userRequestMetadata.commentary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.requestChangeToSave
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: _vm.$t(
                                        "my_tasks.response_request"
                                      ),
                                    },
                                  },
                                  [
                                    _c(VTextarea, {
                                      attrs: {
                                        outlined: !_vm.isOnlyView,
                                        readonly: _vm.isOnlyView,
                                        disabled: _vm.isOnlyView,
                                        filled: _vm.isOnlyView,
                                        dense: "",
                                        rows: "3",
                                        "max-rows": "3",
                                        type: "text",
                                        required: "",
                                        placeholder: _vm.$t(
                                          "my_tasks.response_request"
                                        ),
                                      },
                                      model: {
                                        value: _vm.requestChangeToSave.response,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.requestChangeToSave,
                                            "response",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "requestChangeToSave.response",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _c("b", [_vm._v("Apparently the table has no associated metadata")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }